import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Vehicle } from '../../../models/vehicles/vehicle';
import { AlertService } from '../../../services/alert.service';
import { VehicleService } from '../../../services/vehicle.service';

@Component({
	selector: 'app-vehicle-form',
	templateUrl: './vehicle-form.component.html',
	styleUrls: ['./vehicle-form.component.css']
})
export class VehicleFormComponent implements OnInit {
	form: FormGroup;
	vehicle: Vehicle;
	loading: boolean = false;

	constructor(
		private _vehicleService: VehicleService,
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		this._activatedRoute.params.subscribe(
			x => {
				this.init();
			}
		);
	}

	private init(){
		let id = this._activatedRoute.snapshot.params['id'];
		this.vehicle = new Vehicle();
		this.vehicle.id = id;

		this.form = this.createForm(this.vehicle);

		if (id == 0) {
			this.vehicle.id = 0;
		}
		else {
			this._vehicleService.getVehicle(id).subscribe(
				vehicle => {
					if (vehicle == undefined) {
						this.vehicle.id = 0;
					}
					else {
						this.vehicle = vehicle;
						this.form = this.createForm(this.vehicle)
					}
				}
			);
		}
	}

	private createForm(vehicle: Vehicle): FormGroup {
		return new FormGroup({
			plateNumber: new FormControl(vehicle.plateNumber, [
				Validators.required,
				Validators.maxLength(7),
				Validators.minLength(6)
			]),
			isTruck: new FormControl(vehicle.isTruck, [
				Validators.required
			]),
			isActive: new FormControl(vehicle.isActive, [
				Validators.required
			]),
		});
	}

	onFormSubmit(formValue) {
		if (!this.form.valid) {
			return; //do something here
		}

		//update vehicle item
		this.vehicle.plateNumber = formValue.plateNumber;
		this.vehicle.isTruck = formValue.isTruck;
		this.vehicle.isActive = formValue.isActive;

		this.loading = true;
		if (this.vehicle.id == undefined || this.vehicle.id == 0) {
			this.createVehicle();
		}
		else {
			this.updateVehicle();
		}
	}

	private createVehicle() {
		this._vehicleService.addVehicle(this.vehicle).subscribe(
			result => {
				if (result != undefined || result['object'] != undefined) {
					this.vehicle = result.object;
					this._alertService.showSuccess('Vehicle registered.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	private updateVehicle() {
		this._vehicleService.updateVehicle(this.vehicle).subscribe(
			result => {
				if (result != undefined || result['object'] != undefined) {
					this.vehicle = result.object;
					this._alertService.showSuccess('Vehicle data updated.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	isControlInvalid(controlName: string) {
		let control = this.form.controls[controlName];
		return control.invalid && (control.dirty || control.touched);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/vehicles/vehicle-form/vehicle-form.component.ts